module.exports = __webpack_public_path__ + "assets/images/profiles/2020-3-desktop.jpg?v=8dcd6772";